module.exports = __webpack_public_path__ + "static/12-HOW-CRE-CAN-HELP-DRIVE-BUSINESS-RESILIENCE-AND-PERFORMANCE-028d62f0a07e4061ac394aeeea8bd736.png";